import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=0afcf9c2&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afcf9c2')) {
      api.createRecord('0afcf9c2', component.options)
    } else {
      api.reload('0afcf9c2', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=0afcf9c2&", function () {
      api.rerender('0afcf9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductCard.vue"
export default component.exports